import { lazy } from 'react'

export const InconsistenciesVariant1 = lazy(
  () => import('./InconsistenciesVariant1'),
)
